// extracted by mini-css-extract-plugin
module.exports = {"leadDrawer":"LeadDrawer_leadDrawer__1UR5V","follow_message_container":"LeadDrawer_follow_message_container__1GLqc"};